import { lazy, Suspense, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { ActionModalProvider } from './components/ActionModal'
import { applyTheme, getStoredTheme } from './lib/theme'
import AuthLayout from './layouts/AuthLayout'
import AppLayout from './layouts/AppLayout'

const Landing          = lazy(() => import('./pages/Landing'))
const SignIn           = lazy(() => import('./pages/auth/SignIn'))
const SignUp           = lazy(() => import('./pages/auth/SignUp'))
const Dashboard        = lazy(() => import('./pages/Dashboard'))
const TimeKeeper       = lazy(() => import('./pages/TimeKeeper'))
const ListOnly         = lazy(() => import('./pages/ListOnly'))
const FormOnly         = lazy(() => import('./pages/FormOnly'))
const Profile          = lazy(() => import('./pages/Profile'))
const SearchResults    = lazy(() => import('./pages/SearchResults'))
const UnderConstruction = lazy(() => import('./pages/UnderConstruction'))
const Boards           = lazy(() => import('./pages/Boards'))
const Workbench        = lazy(() => import('./pages/Workbench'))
const ContractorTimeEntry = lazy(() => import('./pages/staffing/ContractorTimeEntry'))
const ReportsList      = lazy(() => import('./pages/reports/ReportsList'))
const ReportView       = lazy(() => import('./pages/reports/ReportView'))
const ReportBuilder    = lazy(() => import('./pages/reports/ReportBuilder'))
const DashboardsList   = lazy(() => import('./pages/dashboards/DashboardsList'))
const DashboardView    = lazy(() => import('./pages/dashboards/DashboardView'))
const OrgManagement    = lazy(() => import('./pages/admin/OrgManagement'))
const TableConfig      = lazy(() => import('./pages/admin/TableConfig'))
const DemoData         = lazy(() => import('./pages/admin/DemoData'))
const VibeLeaders      = lazy(() => import('./pages/admin/VibeLeaders'))
const Documents        = lazy(() => import('./pages/Documents'))

function App() {
    useEffect(() => {
        applyTheme(getStoredTheme())
    }, [])

    return (
        <ActionModalProvider>
            <Suspense fallback={null}>
                <Routes>
                    <Route path="/" element={<Landing />} />

                    <Route element={<AuthLayout />}>
                        <Route path="/signin" element={<SignIn />} />
                        <Route path="/signup" element={<SignUp />} />
                    </Route>

                    <Route element={<AppLayout />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/workbench" element={<Workbench />} />
                        <Route path="/time-keeper" element={<TimeKeeper />} />
                        <Route path="/list-view" element={<ListOnly />} />
                        <Route path="/form-view" element={<FormOnly />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/search" element={<SearchResults />} />
                        <Route path="/boards" element={<Boards />} />
                        <Route path="/under-construction" element={<UnderConstruction />} />
                        <Route path="/staffing/overview" element={<DashboardView dashboardId="d8b6794f-0aa4-4c91-bed1-b4c7ea5db09f" />} />
                        <Route path="/staffing/time-entry" element={<ContractorTimeEntry />} />
                        <Route path="/reports" element={<ReportsList />} />
                        <Route path="/reports/new" element={<ReportBuilder />} />
                        <Route path="/reports/:id" element={<ReportView />} />
                        <Route path="/reports/:id/edit" element={<ReportBuilder />} />
                        <Route path="/dashboards" element={<DashboardsList />} />
                        <Route path="/dashboards/new" element={<DashboardView />} />
                        <Route path="/dashboards/:id" element={<DashboardView />} />
                        <Route path="/admin/org" element={<OrgManagement />} />
                        <Route path="/admin/table-config" element={<TableConfig />} />
                        <Route path="/admin/demo-data" element={<DemoData />} />
                        <Route path="/admin/vibe-leaders" element={<VibeLeaders />} />
                        <Route path="/documents" element={<Documents />} />
                        <Route path="/documents/:doc" element={<Documents />} />
                    </Route>
                </Routes>
            </Suspense>
        </ActionModalProvider>
    )
}

export default App
